import { render, staticRenderFns } from "./VueSelectTempUniversity1.vue?vue&type=template&id=2cf29804&scoped=true&"
import script from "./VueSelectTempUniversity1.vue?vue&type=script&lang=js&"
export * from "./VueSelectTempUniversity1.vue?vue&type=script&lang=js&"
import style0 from "./VueSelectTempUniversity1.vue?vue&type=style&index=0&id=2cf29804&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cf29804",
  null
  
)

export default component.exports